import React from 'react'
import Text from 'orionsoft-parts/lib/components/fields/Text'
import {Form, Field} from 'simple-react-form'
import MultipleFiles from 'App/components/fields/MultipleFiles'
import fileUpload from 'App/helpers/fields/fileUpload'
import Button from 'orionsoft-parts/lib/components/Button'
import withMutation from 'react-apollo-decorators/lib/withMutation'
import gql from 'graphql-tag'
import withOrganization from 'App/Decorators/withOrganization'
import PropTypes from 'prop-types'
import autobind from 'autobind-decorator'
import withMessage from 'orionsoft-parts/lib/decorators/withMessage'
import styles from './styles.css'
import Tooltip from 'orionsoft-parts/lib/components/Tooltip'
import Instructions from './Instructions'
import emailValidation from 'App/helpers/validations/emailValidation'
import MdInfoOutline from 'react-icons/lib/md/info-outline'
import Fingerprint from 'react-icons/lib/md/fingerprint'
import rutFormatter from 'App/helpers/validations/rutFormatter'
import rutValidation from 'App/helpers/validations/rutValidation'
import Select from 'orionsoft-parts/lib/components/fields/Select'
import countries from '../../../Root/countries'
import dniCleaner from '../../../helpers/validations/dniCleaner'

@withOrganization
@withMutation(gql`
  mutation createDactTransaction(

    $files: [FileInput]
    $name: String
    $description: String
    $signerName: String
    $signerEmail: String
    $signerRut: String
    $paisEmisor: String

  ) {
    createDactTransaction(
      files: $files
      name: $name
      description: $description,
      signerName: $signerName,
      signerEmail: $signerEmail,
      signerRut: $signerRut,
      paisEmisor: $paisEmisor
    )
  }
`)

@withMessage
export default class MassiveDactilar extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      failed: [],
      firmasAUsar: 0
    }
  }
  static propTypes = {
    showMessage: PropTypes.func,
    organization: PropTypes.object,
    createDactTransaction: PropTypes.func
  }

  @autobind
  async load() {
    console.log('Subiendo archivos...')
    this.setState({loading: true, errorMessages: null})
    if (!this.state.files) {
      this.props.showMessage('Necesitas cargar los archivos')
      this.setState({loading: false})
      return
    }

    console.log('Voy a iterar por los archivos', this.state.files)
    let fileForServices = []
    this.state.files.forEach(file => {
      console.log("===> Revisando archivo ", file);
      console.log("===> Revisando si es pdf: ", file.file.isPdf);
      fileForServices.push(file.file)
    })
    console.log('fileForServices ', fileForServices)

    try {
      let respuesta = await this.props.createDactTransaction(
        {
          files: fileForServices,
          name: this.state.txName,
          description: this.state.txDesc,
          signerName: this.state.signer,
          signerEmail: this.state.signerEmail,
          signerRut: this.state.rut,
          paisEmisor: this.state.paisEmisor
        },
        {
          refetchQueries: [
            'myDocumentsToSign',
            'myFeaDocumentsToSign',
            'documentCount',
            'organizationDocCount',
            'packsSignaturesCount',
            'planSignaturesCount'
          ]
        }
      )
      console.log('Proceso finalizado: ', respuesta)
      this.props.showMessage('Proceso finalizado con éxito')

    } catch (error) {
      console.log('Error:', error)
    }
    this.setState({loading: false, data: null, files: null})

    setTimeout(() => {
      this.props.router.push('/documents')
    }, 5000
    )

  }

  renderFirmasAGastar() {
    if (this.state.files) {
      return (
        <Tooltip content="">
          <div className="label">Se usarán {this.state.files.length} firmas simples</div>
        </Tooltip>
      )
    }

  }

  render() {
    const {showing} = this.state
    const onRutChange = field => value => {
      console.log('--> onRutChange ' + value + ', rut ')
      console.log('--> onRutChange pais ', this.state.paisEmisor);
      if(this.state.paisEmisor === 'CHL')
        value = rutFormatter(value)
      else 
        value = dniCleaner(value);

      this.setState({'rut': value})
    }

    const onPaisChange = field => value => {
      console.log('--> onPaisChange ' + value  );
      let rutValue = rutFormatter(value)

      if(value === 'CHL')
        rutValue = rutFormatter(this.state.rut)
      else 
        rutValue = dniCleaner(this.state.rut);

      this.setState({
        'rut': rutValue,
        'paisEmisor': value
      });
    }

    const optionCountries = () => {
      let optionCountries = []
      countries.map(c => {
        optionCountries.push({label: c.pais, value: c.codigo})
        return null
      })
      return optionCountries
    }
    return (
      <div className="section">
        <div className="header">
          <div className="row">
            <div className="col-xs-12 col-sm-12 col-md-8 col-lg-8">
              <div className="row">
                <div className="col-xs-2 col-sm-">
                  <div className={styles.Icon}>
                    <Fingerprint size={30} />
                  </div>
                </div>
                <div className="col-xs-10 col-sm-">
                  <div className={styles.Title2}>
                    <h3>Creacion Transacción Dactilar <Tooltip
                      content={'La autenticación debe ser realizada en dispositivos biométricos autorizados por tuFirma.digital'}
                    >
                      <MdInfoOutline size={20} className="info-tooltip"/>
                    </Tooltip></h3>

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {showing ? (
          <div className="content" style={{padding: 0}}>
            <Instructions />
          </div>
        ) : (
          <div className="content">
            <div>
              <Form state={this.state} onChange={changes => this.setState(changes)}>
                <Tooltip content="Documents to send">
                  <div className="label">Documentos</div>
                </Tooltip>
                <Field fieldName="files" {...fileUpload} type={MultipleFiles} />
                <br />

                <Tooltip content="Documents to send">
                  <div className="label">Nombre Transacción</div>
                </Tooltip>
                <Field fieldName="txName" placeholder="Nombre de transacción" type={Text}/>

                <Tooltip content="Documents to send">
                  <div className="label">Descripción</div>
                </Tooltip>
                <Field fieldName="txDesc" placeholder="Descripción (opcional)" type={Text}/>

                <Tooltip content="Documents to send">
                  <div className="label">Nombre Firmante</div>
                </Tooltip>
                <Field fieldName="signer" placeholder="Nombre De Firmante" type={Text}/>

                <Tooltip content="Documents to send">
                  <div className="label">Email Firmante</div>
                </Tooltip>
                <Field fieldName="signerEmail" placeholder="email@noip.cl" type={Text}/>

                <Tooltip content="Documents to send">
                  <div className="label">Rut</div>
                </Tooltip>
                <Field fieldName="rut" onChange={onRutChange()} placeholder="Rut Firmante" type={Text}/>

                <Tooltip content="Pais Emisor de Documento">
                  <div className="label">Pais Emisor de Documento</div>
                </Tooltip>
                <Field
                  fieldName="paisEmisor"
                  onChange={onPaisChange()}
                  placeholder="Pais"
                  type={Select}
                  options={optionCountries()}
                />
                {/* <Field fieldName="paisEmisor" placeholder="CHL" type={Text}/> */}
                <br />

                {this.renderFirmasAGastar()}
                <br />
                <div className="row">
                  <div className="col-xs-12 center-xs col-sm-6 end-sm">
                    <div className={styles.view}>
                      <Button
                        primary
                        onClick={this.load}
                        loading={this.state.loading}
                        disabled={!this.state.files || !this.state.txName || !this.state.signer || !this.state.signerEmail || !emailValidation(this.state.signerEmail) ||
                                    !this.state.rut || !rutValidation(this.state.rut, this.state.paisEmisor) || !this.state.paisEmisor }>
                        Crear Transacción Biométrica
                      </Button>
                    </div>
                  </div>
                </div>
              </Form>

            </div>
          </div>
        )}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/App/Pages/Documents/MassiveDactilar/index.js